import './checkout-gift-cards-success.scss';
